<div *ngIf='{ desktop: (deviceS.isDesktop$|async),
              mobile: (deviceS.isMobile$|async),
            } as obj' class='wrapperMeProfileCalendar'>
  <div *ngIf='obj.desktop' class='headerContact'>
    <headTitle text='Calendar Sync' typeText='text1-blueDark'
      [svgLeft]="obj.mobile ? 'arrow_squareLeft&24' : 'arrow_square_left&32'" (svgLeftEmit)='otherS.locationBack()'>
    </headTitle>
  </div>

  <titleAndNavigationForProfile *ngIf='obj.mobile' [typePageProfile]='typePageProfile'></titleAndNavigationForProfile>

  <div class='content scroll-area' [class.contentContact--desktop]='obj.desktop'>
    <div class='contentCalendar'>
      <div class='contentCalendar__title'>iCalendar Feed URL</div>
      <p>Use your personal Notch iCal URL below to sync your Notch game schedule with your preferred calendar
        application.</p>
      <div class="contentCalendar__copy">
        <form [formGroup]='form' class='formCalendarSync'>
          <field class='calendar-sync-url'>
            <inputCtrl formControlName='calendarSyncUrl' [placeholder]="calendarSyncUrl || ''" [showErrText]='true'
              svgSuffix="copy" (svgRightEmit)='copyUrl()' [divisorySuffixLine]='true'>
            </inputCtrl>
          </field>
        </form>
        <btnWrap type='col'>
          <btn text='How to sync your games with Google Calendar' bcg='white' svgLeft='google&32'
            (click)='showSyncWithGoogle()' textPosition='left' fontSize='14' btnHeight="56px"></btn>
          <btn text='How to sync your games to an Outlook Calendar' bcg='white' svgLeft='outlook&32'
            (click)='showSyncWithOutlook()' textPosition='left' fontSize='14' btnHeight="56px"></btn>
          <btn text='How to sync your games to an Apple Calendar (iCloud Calendar)' bcg='white' svgLeft='apple&32'
            (click)='showSyncWithApple()' textPosition='left' fontSize='14' btnHeight="56px"></btn>
        </btnWrap>
      </div>
    </div>
  </div>